export { default as BaseSettings } from './BaseSettings.vue';
export { default as BaseSettingsTable } from './BaseSettingsTable.vue';
export { default as BaseSettingsPage } from './BaseSettingsPage.vue';
export { default as BaseSettingsPageSidebar } from './BaseSettingsPageSidebar.vue';
export { default as BaseSettingsMenuGroup } from './BaseSettingsMenuGroup.vue';
export { default as BaseSettingsMenuSidebar } from './BaseSettingsMenuSidebar.vue';
export { default as BaseSettingsEmptyResults } from './BaseSettingsEmptyResults.vue';
